var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle10, _circle11, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f766bdcd-0106-4c3c-834e-43c39678388c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 954,
    height: 671.87963,
    viewBox: "0 0 954 671.87963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social_expert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.72623,620.444,882.7639,650.71254l83.25436-38.85242c-28.26887-6.97364-60.28577-10.87691-94.048-10.7469-10.26188.03955-20.34225.442-30.188,1.18169a619.21918,619.21918,0,0,1-82.93617.64939L532.56733,650.71254l181.196-52.21482c-31.49341-4.39284-61.415-11.3824-88.27546-20.92352q-7.51171-2.66823-15.36293-5.12408L246.97012,689.658S398.601,607.59145,503.30127,551.207a652.39579,652.39579,0,0,0-65.54315-3.26717C263.92209,547.93982,123,615.19868,123,698.16675c0,32.7669,21.9844,63.08194,59.29107,87.77307H960.519c68.84988-15.55045,116.48068-49.00457,116.481-87.77274C1077.00028,666.51961,1044.4856,638.20749,994.72623,620.444Z",
    transform: "translate(-123 -114.06018)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M874.99985,667.13725C895.0927,727.6079,888.03607,784.386,888.03607,784.386s-39.63357-41.26416-59.72642-101.73481-13.03622-117.24877-13.03622-117.24877S854.907,606.66661,874.99985,667.13725Z",
    transform: "translate(-123 -114.06018)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M901.0723,667.13725C880.97945,727.6079,888.03607,784.386,888.03607,784.386s39.63357-41.26416,59.72642-101.73481,13.03623-117.24877,13.03623-117.24877S921.16515,606.66661,901.0723,667.13725Z",
    transform: "translate(-123 -114.06018)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M909.165,667.79116c1.34682,63.70721-22.156,115.87205-22.156,115.87205s-25.6864-51.125-27.03322-114.83215,22.156-115.872,22.156-115.872S907.81813,604.084,909.165,667.79116Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 761.57036,
    cy: 497.42819,
    r: 6.23664,
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.44356,
    cy: 547.32133,
    r: 3.4648,
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 707.17299,
    cy: 513.0198,
    r: 3.4648,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.48046,
    cy: 479.41123,
    r: 3.4648,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.18995,
    cy: 545.58893,
    r: 3.4648,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 797.95077,
    cy: 525.49308,
    r: 3.4648,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.26883,
    cy: 596.5215,
    r: 3.4648,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.41557,
    cy: 576.77213,
    r: 3.4648,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 767.807,
    cy: 580.23693,
    r: 3.4648,
    fill: "#6c63ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 667.87976,
    width: 897.00001,
    height: 2,
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M447.29869,90.87963h.00008a37.77586,37.77586,0,0,1,37.77586,37.77586v46.524a0,0,0,0,1,0,0h-75.5518a0,0,0,0,1,0,0v-46.524A37.77586,37.77586,0,0,1,447.29869,90.87963Z",
    fill: "#f7df18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M497.53042,314.68875s-38.57119-12.32688-44.93344-1.19293-1.59057,27.83488,0,34.19713,13.51979,81.11878,45.33108,61.23673S497.53042,314.68875,497.53042,314.68875Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M497.53042,314.68875s-38.57119-12.32688-44.93344-1.19293-1.59057,27.83488,0,34.19713,13.51979,81.11878,45.33108,61.23673S497.53042,314.68875,497.53042,314.68875Z",
    transform: "translate(-123 -114.06018)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M489.97524,340.53542H457.36867s-16.93262-7.95551-7.27339-20.281,45.44693-1.19158,45.44693-1.19158Z",
    transform: "translate(-123 -114.06018)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M688.00048,402.56742l31.81128,31.81128s26.24431-3.18113,31.81129,6.36226-38.17354,10.33867-38.17354,10.33867l-45.33108-45.33108Z",
    transform: "translate(-123 -114.06018)",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M503.495,491.639l-6.36225,60.44144s2.38584,34.19713-11.92924,54.87447S458.164,709.54631,458.164,709.54631,441.463,748.51513,456.57339,750.901s15.11036-25.449,15.11036-25.449l8.7481-31.016s22.2679-40.55939,30.22072-69.18954c0,0,24.65375-36.583,24.65375-54.07918S544.8497,491.639,544.8497,491.639Z",
    transform: "translate(-123 -114.06018)",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M552.80252,500.38712l14.31508,73.96123s.79528,29.42544,3.97641,41.35467c0,0,1.59057,42.94524,7.15754,60.44144s9.54339,43.74052,9.54339,43.74052l-3.97642,7.15754,3.97642,25.449,9.54338,14.31508,10.33867-8.7481L605.29114,708.751s4.77169-73.166-1.59056-89.0716L599.72417,528.222l-.79529-27.83487Z",
    transform: "translate(-123 -114.06018)",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M528.14878,322.24393,499.51862,501.97768s38.17354-3.97641,50.10277,5.567,54.07919,3.97641,54.07919,3.97641l2.11461-165.313-14.04384-31.91692-48.51221-3.97641Z",
    transform: "translate(-123 -114.06018)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M552.00724,262.59777s3.97641,36.583,0,40.55939,42.94523,0,42.94523,0-12.72451-38.17354-11.13395-42.94524S552.00724,262.59777,552.00724,262.59777Z",
    transform: "translate(-123 -114.06018)",
    fill: "#ffb6b6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M552.00724,262.59777s3.97641,36.583,0,40.55939,42.94523,0,42.94523,0-12.72451-38.17354-11.13395-42.94524S552.00724,262.59777,552.00724,262.59777Z",
    transform: "translate(-123 -114.06018)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M570.29873,290.43264l-18.29149-8.7481s-9.54338-3.18113-9.54338,1.59056-6.36226,5.567-3.97641,10.33867,18.29148,21.47262,76.34708,16.70093c0,0,11.92923-3.97642,25.449,5.567,0,0-7.15753-18.29149-41.35467-41.35467Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M542.46386,289.63736s-9.54339,7.15754-9.54339,8.7481S491.5658,417.67778,491.5658,417.67778,415.21872,497.206,421.581,503.56825s8.7481,11.13395,18.29148,12.72451c0,0,21.47262,35.78769,73.96124,30.22072l38.17354-190.07242,14.31508-31.016s-3.97641,130.42626,7.15754,130.42626h14.31508s1.59056,99.41026,10.33866,99.41026,17.49621-3.18113,16.70093-7.15754-2.38585-44.53579-2.38585-44.53579,22.2679,11.92923,22.2679,4.77169-7.95282-65.21313-7.95282-65.21313l-4.77169-138.37909-18.29149-12.72451Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M536.89688,299.18075h-3.97641a32.1899,32.1899,0,0,0-15.90564,3.18112l-55.66975,7.15754s16.70093,1.59057,19.882,20.67734,6.36226,31.016,7.95282,31.81128-8.7481,59.64616,9.54339,67.599,31.016-6.36226,35.78769-27.83487,21.47262-93.84329,21.47262-93.84329Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M625.96848,303.15716l15.90564,12.72451s.79528,10.33867,10.33867,19.08677,46.12636,72.37067,44.53579,73.96124-57.26031,5.567-54.07918,23.06318-19.88205,16.70092-19.88205,16.70092L602.11,323.83449Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M456.021,340.28726,403.24649,288.6432s-41.98534-12.34348-34.4551-21.45787,45.73165,7.38908,45.73165,7.38908l48.86235,39.884-4.46467,24.90192A1.72221,1.72221,0,0,1,456.021,340.28726Z",
    transform: "translate(-123 -114.06018)",
    fill: "#ffb6b6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M450.21113,716.70385l-10.33867,35.78769s-8.7481,28.06319,10.33867,30.449,15.11036-13.51979,15.11036-13.51979l2.44544-25.08905s-14.825,11.81374-15.96523-3.76942a56.50083,56.50083,0,0,1,5.96461-29.02779Z",
    transform: "translate(-123 -114.06018)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M590.18078,777.94057l-2.38584-11.134h-4.7717l-3.97641-3.97641s4.77169-17.4962,1.59057-25.449-1.59057-16.70092,7.15754-17.4962c0,0-5.567,23.85846,7.95282,36.583,0,0,12.41913,7.20857,11.77654-1.565l.15269-9.92271,3.18113,13.07832s2.38584,12.72451,6.36225,15.90564,1.59057,10.33867-9.54338,8.7481S590.18078,777.94057,590.18078,777.94057Z",
    transform: "translate(-123 -114.06018)",
    fill: "#2f2e41"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.71996,
    cy: 206.99082,
    r: 2.38585,
    fill: "#2f2e41"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.90109,
    cy: 131.43902,
    r: 27.83487,
    fill: "#ffb6b6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M539.68037,247.08977,561.153,220.84546s23.85847,28.63015,40.55939,27.83487l3.18113-16.70092-15.90564-15.90564-19.882-4.7717L550.019,215.27848l-15.71056,15.93305Z",
    transform: "translate(-123 -114.06018)",
    fill: "#f7df18"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M733.23131,210.9419a21.82987,21.82987,0,0,0-8.76044,41.824,19.3316,19.3316,0,0,1,.38-5.00874c.419-1.77353,2.80646-11.89821,2.80646-11.89821a8.33337,8.33337,0,0,1-.70161-3.4496c0-3.23522,1.871-5.6519,4.20968-5.6519,1.98791,0,2.94288,1.49093,2.94288,3.2742,0,1.99766-1.27655,4.97952-1.92944,7.747a3.37472,3.37472,0,0,0,3.44961,4.19994c4.13173,0,6.91869-5.31083,6.91869-11.60587,0-4.78462-3.22547-8.36091-9.082-8.36091a10.343,10.343,0,0,0-10.74834,10.456,6.292,6.292,0,0,0,1.44221,4.27789,1.0669,1.0669,0,0,1,.31182,1.21808c-.10719.39953-.34106,1.36425-.44825,1.754a.75.75,0,0,1-1.0914.5457c-3.05007-1.24731-4.47279-4.58-4.47279-8.34142,0-6.19759,5.23287-13.63275,15.60117-13.63275,8.33167,0,13.81791,6.03193,13.81791,12.50238,0,8.56554-4.76513,14.958-11.78127,14.958a6.26369,6.26369,0,0,1-5.33032-2.71875s-1.26681,5.02823-1.53966,6.0027a18.14334,18.14334,0,0,1-2.19254,4.67743,21.83171,21.83171,0,1,0,6.19759-42.76924Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M351.14323,118.494a19.07422,19.07422,0,0,1-5.418,1.49093,9.46745,9.46745,0,0,0,4.15122-5.22313,18.74662,18.74662,0,0,1-5.993,2.29,9.43159,9.43159,0,0,0-16.32227,6.451,9.23646,9.23646,0,0,0,.24361,2.15357A26.73668,26.73668,0,0,1,308.3545,115.785a9.45314,9.45314,0,0,0,2.93314,12.60957A9.21458,9.21458,0,0,1,307,127.21545v.11693a9.44263,9.44263,0,0,0,7.57159,9.25741,9.49662,9.49662,0,0,1-2.48489.33132,8.90078,8.90078,0,0,1-1.77352-.1754,9.44937,9.44937,0,0,0,8.8189,6.55814,18.9155,18.9155,0,0,1-11.72281,4.044,19.12205,19.12205,0,0,1-2.251-.13643,26.37077,26.37077,0,0,0,14.44156,4.26816c17.3747,0,26.866-14.39284,26.866-26.87572,0-.40928-.00974-.81855-.02923-1.21808A19.20521,19.20521,0,0,0,351.14323,118.494Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M753.66516,362.06018h-33.2877a2.06692,2.06692,0,0,0-2.06586,2.06587v33.28769a2.06692,2.06692,0,0,0,2.06586,2.06587h16.64385V384.66775h-4.47279v-5.457h4.47279v-4.03428c0-4.83334,3.35216-7.46439,7.669-7.46439,2.06586,0,4.28764.15591,4.80411.22412v5.04773H746.0546c-2.34846,0-2.79671,1.11089-2.79671,2.748v3.47883h5.59342l-.73085,5.457h-4.86257v14.81186h10.40727a2.06692,2.06692,0,0,0,2.06587-2.06587V364.12605A2.06692,2.06692,0,0,0,753.66516,362.06018Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M395.196,208.081a7.81863,7.81863,0,0,1,7.79571,7.79572v15.59142a7.81863,7.81863,0,0,1-7.79571,7.79572H379.60453a7.81863,7.81863,0,0,1-7.79571-7.79572V215.87674a7.81863,7.81863,0,0,1,7.79571-7.79572H395.196m0-3.11828H379.60453a10.94609,10.94609,0,0,0-10.914,10.914v15.59142a10.94609,10.94609,0,0,0,10.914,10.914H395.196a10.94609,10.94609,0,0,0,10.914-10.914V215.87674A10.94609,10.94609,0,0,0,395.196,204.96274Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M397.53467,215.87674a2.33872,2.33872,0,1,1,2.33872-2.33872A2.33311,2.33311,0,0,1,397.53467,215.87674Zm-10.13442,1.55914a6.23657,6.23657,0,1,1-6.23658,6.23657,6.24235,6.24235,0,0,1,6.23658-6.23657m0-3.11829a9.35486,9.35486,0,1,0,9.35485,9.35486A9.35728,9.35728,0,0,0,387.40025,214.31759Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M829.79835,284.96274H798.57652a3.05186,3.05186,0,0,0-3.19624,2.91365v31.29a3.29166,3.29166,0,0,0,3.19624,3.206h31.21209a3.12463,3.12463,0,0,0,3.00134-3.206v-31.29A2.8684,2.8684,0,0,0,829.79835,284.96274Zm-22.822,31.18285h-5.35955V299.48225h5.35955Zm-2.49463-19.19694h-.039a2.91391,2.91391,0,1,1,.039,0Zm22.08136,19.19694h-5.35955v-9.11124c0-2.1828-.77957-3.67373-2.71876-3.67373a2.93233,2.93233,0,0,0-2.748,1.97816,3.60844,3.60844,0,0,0-.18514,1.31553v9.49128h-5.35956V299.48225h5.35956v2.31923a5.42513,5.42513,0,0,1,4.83334-2.709c3.51781,0,6.1781,2.31922,6.1781,7.31823Z",
    transform: "translate(-123 -114.06018)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.5d1d21cd68e75f1dba652f1869f5c842.svg";
export { ForwardRef as ReactComponent };